import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { BASE_URL } from "../../config/axios";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { useLocation, useParams } from "react-router-dom";
// import { BillingDetailsTable, BillTable, ConsultancyDetails, ContractorDetails, COSTable, EmployeeTable, EOTTable, LetterTracking, MilestoneTable, Progress } from "./SiteProjectManagementComponents";
// import { handleErrorToast, formatCurrencyIndian, formatRoundoffCrores, formatRoundoff3D } from "../custom";
import Tabledesign from "../../components/Designstage/Tabledesign";
import TableReviewfile from "../../components/ReviewFile/TableReviewfile";
import { CircularGrid, Documentation } from "../AllSvg";
// import usePermission from "../../config/permissions";
// import { UpdateProject } from "../Modals/UpdateProjectDetails";
// import { AddProjectClientDetails, ProjectClientDetailsTable, ProjectInvoicesDetailsTable, ProjectInvoicesPaymentsTable, ProjectSubmissionDocumentTable, ProjectTenderDocumentTable } from "./ProjectDetailsPageComponents"
import { UpdateProject, AddDepartmentDetails } from "../Modals/UpdateProjectDetails";
// import { formattedDateLong } from "../Date";
// import UpdateProjectDetails from "../Modals/UpdateProjectDetails"

import {
    AddActivity,
    AddDepartment,
    EditActivity
} from "../Project/AllProjectdetailsmodal";
import Department from "../AddDepartment/Department"

const ProjectDetails = () => {

    const location = useLocation();

    const projectID = location?.state?.projectId;
    console.log(projectID);

    const [buffer, setBuffering] = useState(false);

    const [clientslist, setClientsList] = useState([]);
    const [clientExists, setClientExists] = useState(false);

    const [client, setClient] = useState(null);
    const [clientwiseID, setClientWise] = useState(null);

    const [toggleState, settoggleState] = useState(1);

    const [project, setProject] = useState({});
    const [departmentlist, setDepartmentlist] = useState([]);
    const getProjectDetails = async () => {
        try {
            const ress = await axios.get(
                `${BASE_URL}/detail-design/projectupdate/${projectID}/`
            );
            setProject(ress.data);
            console.log({ ProjectData: ress.data })
        } catch (err) { }
    };

    // const getDepartmentList = async () => {
    //     try {
    //         const ress = await axios.get(
    //             `${BASE_URL}/detail-design/highwaydepartment/`
    //         );
    //         setDepartmentlist(ress.data);
    //     } catch (err) { }
    // };

    // const getProjectClientList = async () => {
    //     setBuffering(true);
    //     try {
    //         const clientdetails = await axios.get(
    //             `${BASE_URL}/detail-design/client/${projectID}/`
    //         );
    //         setClientsList(clientdetails.data);
    //         setClientExists(clientdetails.data?.normal_client.length > 0);
    //         settoggleState(
    //             clientdetails.data?.normal_client.length > 0 ? 1 : 5
    //         );

    //         console.log("clientdetails");
    //         console.log(clientdetails.data?.normal_client?.length > 0);

    //         setClient(clientdetails.data?.normal_client[0]?.client);
    //         setClientWise(clientdetails.data?.normal_client[0]?.id);
    //         if (clientdetails.data?.normal_client?.length > 0) {
    //         } else {
    //             setClient(undefined);
    //             setClientWise(undefined);
    //         }
    //     } catch (err) {
    //         // handleErrorToast(err);
    //     } finally {
    //         setBuffering(false);
    //     }
    // };

    useEffect(() => {
        if (projectID) {
            getProjectDetails();
        }

        // getProjectClientList();
        getDepartmentData();
    }, [location]);

    const [allEmployeeData, setAllEmployeeData] = useState([]);

    useEffect(() => {
        getEmployeeDetails();
        getDepartmentData();
    }, []);

    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanysdep/${sessionStorage.getItem(
                    "departmentid"
                )}/`
            );
            setAllEmployeeData(res.data);
        } catch (err) {
            alert(err.message);
        }
    };

    const getDepartmentData = async () => {
        console.log("function running")
        try {
            const res = await axios.get(
                `${BASE_URL}/detail-design/HighwayDepartmentFilterbyProject/${projectID}/`
            );
            setDepartmentlist(res.data);

            console.log({ dept: res.data })
        } catch (err) {
            alert(err.message);
        }
    };


    // const getSelectedTitle = () => {
    //     switch (toggleState) {
    //         case 1:
    //             return "Design Stage";
    //         case 2:
    //             return "Review File";

    //         default:
    //             return "Design Stage";
    //     }
    // };
    return (

        <>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Dashboardnavbar name={`Project Details`} url="Project Details" />

            <div className="content-tabs">
                <div className="info-box-div-bg">
                    <div className="flex-row">
                        <div className="personal-detail" style={{ width: "100%" }}>
                            <div className="jd-heading-outer heading-bg-color-white" style={{ marginBottom: "10px", marginTop: '10px' }}>
                                <div className="jd-heading-outer-flex" style={{ alignItems: 'center' }}>
                                    <div className="project-del">
                                        <tr>
                                            <td className=" jd-heading-main font-weight600  font-size-heading">
                                                Project detail : ' {project.project_name} '
                                            </td>
                                        </tr>
                                    </div>

                                    <div className="jd-heading-outer-flex" style={{ alignItems: 'center', gap: "16px" }}>
                                        <UpdateProject
                                            id={project.pr_code}
                                            modalData={project}
                                            allEmployeeData={allEmployeeData}
                                            getProjectDetails={getProjectDetails}
                                        />
                                        {/* <UpdateProject
                                            id={project.pr_code}
                                            modalData={project}
                                            allEmployeeData={allEmployeeData}
                                            getProjectDetails={getProjectDetails}
                                        /> */}
                                    </div>
                                </div>

                            </div>

                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>

                            <div className="info-box-div">
                                <div className="jd-heading-outer-flex" style={{ alignItems: 'center', marginTop: '20px' }}>
                                    <h3 className="personal-detail-1 font-weight500 font-size-text">
                                        Description : <span className="personal-detail-2 font-weight500  font-size-text">{project?.project_description ? project.project_description : "-"} </span>
                                    </h3>
                                </div>
                                {console.log({ project })}

                                <div className="personal-detail" style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                    <div>
                                        <table>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    Client Name :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.clientname ? project.clientname : "-"}
                                                </th>
                                            </tr>




                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    Business Unit Head :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.concern_person ? project.concern_person : "-"}
                                                </th>
                                            </tr>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    Location :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.location ? project.location : "-"}
                                                </th>
                                            </tr>
                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    Length (in Km) :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.length ? project.length : "-"}
                                                </th>
                                            </tr>
                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    WO Amount :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.woamount ? project.woamount : "-"}
                                                </th>
                                            </tr>



                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    GST Amount:
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.gst_amount ? project.gst_amount : "-"}
                                                </th>
                                            </tr>

                                        </table>

                                    </div>
                                    <div>

                                        <table>
                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    Month :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.start_date ? project.start_date : "-"}
                                                </th>
                                            </tr>
                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    Award Date :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.wo_date ? project.wo_date : "-"}
                                                </th>
                                            </tr>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    WO Date :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.wo_date ? project.wo_date : "-"}

                                                </th>
                                            </tr>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    Start Date:
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.start_date ? project.start_date : "-"}
                                                </th>
                                            </tr>

                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    Due Date:
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.due_date ? project.due_date : "-"}
                                                </th>
                                            </tr>
                                            <tr>
                                                <td className="personal-detail-1 font-weight500 font-size-text">
                                                    Status :
                                                </td>
                                                <th className="personal-detail-2 font-weight500 font-size-text">
                                                    {project.project_status ? project.project_status : "-"}
                                                </th>
                                            </tr>



                                        </table>

                                    </div>
                                </div>

                            </div>
                            <div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>


                        </div>
                    </div>
                </div>



                {
                    <div className="filter-outer-box padding-x">
                        <div
                            className="toggle-button-area"
                            style={{
                                padding: "0px 0px 0px 0px",
                                width: "100%",
                            }}
                        >
                            <div className="left-expense-bloc-tab wfm-margin">
                                <div>

                                    {departmentlist.length > 0 && departmentlist.map((dept, index) => (
                                        <button
                                            key={dept.id}
                                            className={
                                                toggleState === index + 1
                                                    ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                                    : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                            }
                                            onClick={() => settoggleState(index + 1)}
                                        >
                                            {dept?.division_data?.name}
                                        </button>
                                    ))}
                                </div>

                            </div>
                            <div className="right-expense-bloc-tab">
                                <div>
                                    <AddDepartment
                                        projectID={projectID}
                                        getDepartmentList={getDepartmentData}
                                        departmentlist={departmentlist}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                }



                <>
                    {/* {toggleState === 1 ? <Department /> : null} */}

                    {departmentlist.length > 0 && departmentlist.map((dept, index) => {

                        return toggleState === index + 1 ? (
                            <Department
                                key={index}
                                projectId={projectID}
                                departmentData={dept}
                                getDepartmentList={getDepartmentData}
                                departmentlist={departmentlist}
                            />
                        ) : null;
                    })}
                    {/* {toggleState === 2 ? <TableReviewfile projectID={projectID} /> : null} */}


                </>
            </div>
        </>
    );
};

export default ProjectDetails;
